if (!customElements.get('cart-variant-change')) {
    class CartVariantChange extends HTMLElement {

        constructor() {
            super();
            this._loading = false;
            this.key = this.dataset.key;
            this.index = this.dataset.index;
            this.option = this.dataset.option;
            this.selected = this.dataset.selected;
            this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);
            this.product = JSON.parse(document.querySelector(`[data-product="${this.key}"]`)?.innerText);
            this.selectChange = this.querySelector(`select[name="change-variant-${this.key}-${this.option}"]`);
            this.cartItems = document.querySelector('#cart-items');
        }

        get loading() { return this._loading; }

        set loading(value) {
            this._loading = value;
            this.selectChange.disabled = value;

            const loader = document.querySelector(`#cart-item-${parseInt(this.index) + 1} .cart-item__loader`);
            if (loader) loader.hidden = !value;

            if (value)
                this.cartItems.classList.add('pointer-events-none');
            else
                this.cartItems.classList.remove('pointer-events-none');
        }

        connectedCallback() {
            this.selectChange?.addEventListener('change', this.handleSelectChange.bind(this));
        }

        disconnectedCallback() {
            this.selectChange?.removeEventListener('change', this.handleSelectChange.bind(this));
        }

        async handleSelectChange(e) {
            const { target } = e;
            const { value } = target;
            if (value == this.selected) return;

            this.loading = true;

            // const optionIndex = this.product.options.findIndex((option) => option == this.option);
            // const variants = this.product.variants.filter((variant) => variant[`option${optionIndex + 1}`] == value);

            const optionIndex = this.product.products_data[0]?.options.findIndex((option) => option == this.option);
            const variants = this.product.products_data[0]?.variants.filter((variant) => variant[`option${optionIndex + 1}`] == value);

            if (!variants.length) {
                this.loading = false;
                return;
            }

            if(document.querySelector(`cart-items`)){
               document.querySelector(`cart-items`).enableLoading();
            }

            this.selected = value;


            const { id, sku } = variants[0];
            const { quantity } = this.item;

            const price = await this.productPriceRequest(id);
            const is_deposit_ref_id = this.product.products_data[1]?.[id]; // getting selected variant deposit ref

            await this.removeItem();
            await this.addItem(id, quantity, price, sku, is_deposit_ref_id);

            window.checkout.render();

            // Dispatch cart added event
            document.dispatchEvent(new CustomEvent('cart:item:added', {
                detail: { timestamp: Date.now(), source: 'cart-items-updated' }
            }));
        }

        async removeItem() {
            return fetch(`${window.theme.routes.cartChange}.js`, {
                method: 'POST',
                headers: window.getCartHeaders(),
                body: JSON.stringify({
                    id: this.key,
                    quantity: 0,
                })
            })
        }

        async addItem(id, quantity, price, identifier, deposit_id) {
            return fetch(`${window.theme.routes.cartAdd}.js`, {
                method: 'POST',
                headers: window.getCartHeaders(),
                body: JSON.stringify({
                    items: [{
                        id,
                        quantity,
                        properties: {
                            '_price': price,
                            '_identifier': identifier,
                            '_deposit_reference': deposit_id,
                        }
                    }]
                })
            })
        }

        async productPriceRequest(id) {
            const productPriceRequest = await fetch(`/products/${this.item.handle}?variant=${id}&view=json`);
            const { selected_variant } = await productPriceRequest.json();
            const { price } = selected_variant;
            return price;
        }
    }

    customElements.define('cart-variant-change', CartVariantChange);
}
